import { Pipe, PipeTransform } from "@angular/core";
import { Injectable } from '@angular/core';
import { format, Locale } from 'date-fns'

@Pipe({ name: 'dateRange' })
export class DateRangePipe implements PipeTransform {
    transform(value: [Date | string, Date | string], formatString: string, separatorString: string = '-', locale: Locale) {
        if (value && value.length == 2) {
            console.log('valid')
            
            let startDate = new Date(value[0]);
            let endDate = new Date(value[1]);

            let formattedStartDate = format(startDate, formatString, { locale: locale });
            let formattedEndDate = format(endDate, formatString, { locale: locale });

            if (formattedStartDate == formattedEndDate) {
                return formattedStartDate;
            } else {
                return `${formattedStartDate} ${separatorString} ${formattedEndDate}`;
            }
        } else {
            return '-'
        }
    }
}